/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * List of parameters
 */
export interface ParameterResult {
  /**
   * Parameter internal id
   */
  parameterId?: string;
  /**
   * Parameter name
   */
  parameterName?: string;
}
